// extracted by mini-css-extract-plugin
export var svgBlack = "ck_jP";
export var svgInverted = "ck_kj";
export var svgReviewsIOLogo = "ck_kh";
export var svgWhite = "ck_jN";